
    import {
        computed,
        defineComponent,
        unref,
        type PropType,
        type VNode,
        ref,
        toRefs,
    } from 'vue';
    import { type ITourProduct } from '@entities/tourProduct';
    import Dropdown from '@ve/components/dropdown/desktop/Dropdown.vue';
    import IsExclusiveFilter from '@ve/components/filters/isExclusiveFilter/desktop/IsExclusiveFilter.vue';
    import useAdditionalFiltersHotel from '../common/useAdditionalFiltersHotel';
    import { DirectFlightFilter } from '@features/tourProduct/filterTourProducts';

    export default defineComponent({
        name: 'AdditionalFiltersHotel',
        components: {
            Dropdown,
            IsExclusiveFilter,
            DirectFlightFilter,
        },
        setup(props, ctx) {

            const {
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                isExclusiveChanged,
                directFlightChanged,
                isExclusiveSelected,
                directFlightSelected,
                directFlightFilterShow,
                additionalFiltersHidden,
                numOfSelected,
            } = useAdditionalFiltersHotel(ctx);

            const isAdditionalFilterVisible = computed(() => unref(isExclusiveFilterShow) || unref(directFlightFilterShow));
            return {
                additionalFiltersHidden,
                selectedFiltersText,
                isExclusiveFilterShow,
                isProductTypeAllOrTourOffer,
                directFlightFilterShow,
                isExclusiveChanged,
                directFlightChanged,
                isExclusiveSelected,
                directFlightSelected,
                isAdditionalFilterVisible,
                numOfSelected,
            };
        },
    });
